import React, { useContext } from 'react';
import styled from 'styled-components';
import { EnterYourComment, Comment } from 'components';
import { FirebaseContext } from 'context';
import queryString from 'query-string';

function Comments({
  commentBeingEdited,
  comments,
  handleEditComment,
  handlePostComment,
  handleDeleteComment,
  idOfCommentBeingRepliedTo,
  postingOrEditingComment,
  setCommentBeingEdited,
  setIdOfCommentBeingRepliedTo,
  setQuestionIdQueryParam,
  users,
  sessionId,
  deletingComment,
  handleDialog,
  onlineUsers
}) {
  const { user } = useContext(FirebaseContext);
  const location = window?.location;
  const queryParams = queryString.parse(location?.search);
  const commentIdQueryParam = queryParams?.commentId;
  return user ? (
    <Container>
      {comments.length > 0
        ? comments
            .filter((comment) => !comment.parentCommentId)
            .map((comment, i, arr) => (
              <Comment
                i={i}
                arr={arr}
                parentCommentId={null}
                commentBeingEdited={commentBeingEdited}
                comments={comments}
                comment={comment}
                handleEditComment={handleEditComment}
                handlePostComment={handlePostComment}
                handleDeleteComment={handleDeleteComment}
                idOfCommentBeingRepliedTo={idOfCommentBeingRepliedTo}
                key={comment.id}
                level={0}
                postingOrEditingComment={postingOrEditingComment}
                setCommentBeingEdited={setCommentBeingEdited}
                setIdOfCommentBeingRepliedTo={setIdOfCommentBeingRepliedTo}
                user={user}
                setQuestionIdQueryParam={setQuestionIdQueryParam}
                users={users}
                commentIdQueryParam={commentIdQueryParam}
                sessionId={sessionId}
                deletingComment={deletingComment}
                handleDialog={handleDialog}
                onlineUsers={onlineUsers}
              />
            ))
        : null}
      {(sessionId === 'x0ffd4' ||
        (sessionId === 'hl1t9c' &&
          !user?.isModerator?.includes(sessionId))) && (
        <EnterYourComment
          handlePostComment={handlePostComment}
          postingOrEditingComment={postingOrEditingComment}
          users={users}
          uid={user.uid}
          sessionId={sessionId}
        />
      )}
    </Container>
  ) : null;
}

const Container = styled.div`
  border-radius: var(--border-radius-md);
  margin: 0 1.25rem;

  @media (min-width: 1200px) {
    margin: 0;
  }
`;

export default Comments;
